import React, { useState } from 'react';
import './questionPagination.scss';
import { useIsMobile } from '../../hooks/isMobile';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../hooks/Dialog';
// import QuestionPaper from './QuestionPaper';
// import Instructions from './Instructions';

const QuestionPagination = ({
  totalQuestions,
  currentQuestion,
  answeredQuestions,
  markedQuestions,
  visitedQuestions,
  onQuestionChange,
  onSectionSubmit,
  activeSection,
  questionsList,
}) => {
  const isMobile = useIsMobile();
  const [questionPaperDialogOpen, setQuestionPaperDialogOpen] = useState(false);
  const [instructionsDialogOpen, setInstructionsDialogOpen] = useState(false);

  const instructionsList = [/* same list as above... */];

  const getQuestionClass = (num) => {
    let className = "question-button";
    if (currentQuestion === num) className += " current";
    if (answeredQuestions.includes(num)) className += " answered";
    else if (markedQuestions.includes(num)) className += " marked";
    else if (visitedQuestions.includes(num)) className += " visited";
    else className += " not-visited";
    return className;
  };

  return (
    <div className="question-pagination">
      <div className="topBox">

        <div className="section-title">SECTION : {activeSection}</div>

        <div className="question-grid">
          {Array.from({ length: totalQuestions }, (_, i) => i + 1).map((num) => (
            <button
              key={num}
              className={getQuestionClass(num)}
            // onClick={() => onQuestionChange(num)}
            >
              {num}
            </button>
          ))}
        </div>

        <div className="legend-box">
          <div className="legend-item answered">
            <div className="dot" />
            <span>Answered</span>
          </div>
          <div className="legend-item marked">
            <div className="dot" />
            <span>Marked and answered</span>
          </div>
          <div className="legend-item not-visited">
            <div className="dot" />
            <span>Not Visited</span>
          </div>
          <div className="legend-item visited">
            <div className="dot" />
            <span>Not Answered</span>
          </div>
        </div>
      </div>

      <div className="actions">
        <div className="action-buttons">
          <button
          // onClick={() => setQuestionPaperDialogOpen(true)}
          >Question Paper</button>
          <button
          // onClick={() => setInstructionsDialogOpen(true)}
          >Instructions</button>
        </div>
        <button className="submit-btn"
        // onClick={onSectionSubmit}
        >Submit Test</button>
      </div>

      <Dialog open={questionPaperDialogOpen} onOpenChange={setQuestionPaperDialogOpen}>
        <DialogContent className="dialog-content">
          <div className="dialog-inner">
            <DialogHeader>
              <DialogTitle>Question Paper - {activeSection}</DialogTitle>
            </DialogHeader>
            <div className="dialog-body">
              {/* <QuestionPaper questions={questionsList} /> */}
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <Dialog open={instructionsDialogOpen} onOpenChange={setInstructionsDialogOpen}>
        <DialogContent className="dialog-content">
          <div className="dialog-inner">
            <DialogHeader>
              <DialogTitle>General Instructions</DialogTitle>
            </DialogHeader>
            <div className="dialog-body">
              {/* <Instructions instructions={instructionsList} /> */}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default QuestionPagination;
